// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"LikeButton_root__29M_N","icon":"LikeButton_icon__CgRbb"};